import { createQueryPreloader } from '@apollo/client';
import { createFileRoute } from '@tanstack/react-router';

// relative imports
import AccountSettingsPage from '../../../../../../components/account-management/settings/AccountSettingsPage';
import LoadingPage from '../../../../../../components/shared/page-components/LoadingPage';
import { ALL_USERS_QUERY } from '../../../../../../data/apollo/queries';
import { isModuleEnabled } from '../../../../../../data/app-config/configs/configUtilities';

function ClientAppSettings() {
  return <AccountSettingsPage />;
}

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/settings',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ClientAppSettings,
  staticData: {
    configPageId: 'account-settings',
    isClientRoute: true,
    meta: {
      title: 'Client Settings | Ledgible',
    },
  },
  beforeLoad: ({ context: { apolloClient }, params: { accountId } }) => {
    if (isModuleEnabled({ moduleName: 'teamManagement' })) {
      const preloadQuery = createQueryPreloader(apolloClient);
      const usersQueryRef = preloadQuery(ALL_USERS_QUERY, {
        variables: {
          accountId,
        },
        fetchPolicy: 'cache-and-network',
      });

      return { usersQueryRef };
    }

    return {};
  },
});
